export const LOCAL_STORAGE_TABLE_DATA = "zebrabi:table-data";
export const LOCAL_STORAGE_MATRIX_DATA = "zebrabi:matrix-data";
export const LOCAL_STORAGE_X_SPREADSHEET_DATA = "zebrabi:x-spreadsheet-data";
